/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Integration_Faq_2_QuestionInputs */

const en_svc_integration_faq_2_question = /** @type {(inputs: Svc_Integration_Faq_2_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Which AI models do you use?`)
};

const lv_svc_integration_faq_2_question = /** @type {(inputs: Svc_Integration_Faq_2_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kādus AI modeļus izmantojat?`)
};

/**
* | output |
* | --- |
* | "Which AI models do you use?" |
*
* @param {Svc_Integration_Faq_2_QuestionInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const svc_integration_faq_2_question = /** @type {((inputs?: Svc_Integration_Faq_2_QuestionInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Integration_Faq_2_QuestionInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_svc_integration_faq_2_question(inputs)
	return en_svc_integration_faq_2_question(inputs)
});